import { render, staticRenderFns } from "./tabChat.vue?vue&type=template&id=7d3b035f&"
import script from "./tabChat.vue?vue&type=script&lang=js&"
export * from "./tabChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports